import React from 'react';
import styled from 'App/styled';
import { listingIdName } from './Scroll/constants';
import FiltersAndSort from './FiltersAndSort';
import Listing from './Listing';
import { PageJourney } from '@nykaa/data-layer/store/action';

const ListingWrapper = styled.div`
  display: flex;
  position: relative;
  .product-listing {
    display: flex;
    flex-direction: column;
    flex: 1 1 0%;
    margin: 0 10px;
  }
  .filters {
    max-width: 270px;
    min-width: 270px;
    margin: 0 10px;
  }
`;

interface Props {
  isSearch?: boolean;
  journeyData?: PageJourney;
  tagsOnListingEnabled?: boolean;
  tagsV2Enabled?: boolean;
}

const ListingComponent = ({
  isSearch = false,
  journeyData,
  tagsOnListingEnabled,
  tagsV2Enabled,
}: Props) => (
  <ListingWrapper id={listingIdName}>
    <div
      className="filters"
      role="navigation"
      aria-label="Side"
    >
      <FiltersAndSort isSearch={isSearch} />
    </div>
    <div className="product-listing">
      <Listing
        isSearch={isSearch}
        journeyData={journeyData}
        tagsOnListingEnabled={tagsOnListingEnabled}
        tagsV2Enabled={tagsV2Enabled}
      />
    </div>
  </ListingWrapper>
);

export default ListingComponent;
